<template>
  <b-container fluid>
    <b-overlay :show="loadingList">
    <b-row>
        <b-col>
          <b-overlay :v-show="unitLoad">
            <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" >
                    <table class="table table-bordered">
                        <tr class="bg-light">
                            <th width="100px">{{ $t("globalTrans.sl_no") }}</th>
                            <th>{{ $t("production_store.pro_name") }}</th>
                            <th>{{ $t("production_store.unit") }}</th>
                            <th>{{ $t("sales_distribution_admin.delivered_quantity") }}</th>
                            <th>{{ $t("sales_center.received_quantity") }}</th>
                            <th>{{ $t("sales_center.receive_quantity") }}</th>
                        </tr>
                        <tr v-for="(item, index) in dataArray.details" :key="index">
                            <td>{{ $n(index + 1) }}</td>
                            <td>{{ productNameById(item.product_id) }}</td>
                            <td>{{ unitNameById(item.unit_id) }}</td>
                            <td>{{ $n(item.quantity) }}</td>
                            <td>{{ $n(item.receive_quantity) }}</td>
                            <td>
                                <ValidationProvider name="Receive quantity" vid="receive_quantity"  rules="required|numeric">
                                    <b-form-group
                                        slot-scope="{ valid, errors }">
                                        <b-form-input
                                            id="receive_quantity"
                                            v-model="item.rec_quantity"
                                           @input="changeQty(item)"
                                            :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </td>
                        </tr>
                    </table>
                    <div class="row">
                        <div class="col text-right">
                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                            &nbsp;
                            <b-button @click="cancel()" variant="danger" class="mr-1">{{ $t('globalTrans.cancel') }}</b-button>
                        </div>
                    </div>
                </b-form>
            </ValidationObserver>
          </b-overlay>
        </b-col>
    </b-row>
    </b-overlay>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { deliveryOrderReceiveStoreApi } from '../../api/routes'
export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      saveBtnName: this.$t('globalTrans.save'),
      dataArray: {
        org_id: this.$store.state.Auth.authUser.org_id,
        sales_center_id: '',
        delivery_id: '',
        demmand_id: '',
        sumTotal: 0,
        details: []
      },
      productList: {},
      loadingList: false,
      unitLoad: false,
      sl: 0,
      loading: false
    }
  },
  created () {
    if (this.id) {
      const tmp = this.getDeliveryDetails()
      tmp.demand_details.forEach(productItem => {
        productItem.rec_quantity = ''
        productItem.total = 0
      })
      this.dataArray.demmand_id = tmp.demmand_id
      this.dataArray.sales_center_id = tmp.sales_center_id
      this.dataArray.product_type = tmp.product_type
      this.dataArray.delivery_id = this.id
      this.dataArray.delivery_order_id = tmp.delivery_id
      this.dataArray.details = tmp.demand_details
    }
    this.getGrandTotal()
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    categoryList: function () {
      return this.productCommonObj.productCategoryList.filter(
        (item) => item.status === 1
      )
    },
    salesCenterList: function () {
      return this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  methods: {
    getGrandTotal () {
      let sumM = 0
      this.dataArray.details.forEach(function (data) {
        sumM = sumM + parseFloat(data.total)
      })
      this.dataArray.sumTotal = parseFloat(sumM) ? sumM : 0
    },
    changeQty (item) {
        const result = parseFloat(item.rec_quantity) * parseFloat(item.unit_price)
        item.total = parseFloat(result.toFixed(2))
        this.getGrandTotal()
    },
    getDeliveryDetails () {
      const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
      return tmpData
    },
    cancel () {
      this.$bvModal.hide('modal-receive')
    },
    async saveData () {
        this.$store.dispatch('mutateCommonProperties', { loading: true })
        let result = null
        this.loadingList = true
        const loadingState = { loading: false, listReload: false }
        result = await RestApi.postData(productionServiceBaseUrl, deliveryOrderReceiveStoreApi, this.dataArray)
        loadingState.listReload = true
        this.loadingList = false
        this.$store.dispatch('mutateCommonProperties', loadingState)
        if (result.success) {
            this.$bvModal.hide('modal-receive')
            if (result.notification && this.$store.state.emitNotification) {
                const notification = result.notification
                this.$socket.emit('send-notification', notification)
            }
            this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
            this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.$t('globalTrans.save_msg'),
                color: '#D6E09B'
            })
        } else {
            this.$refs.form.setErrors(result.errors)
        }
    },
    productNameById (id) {
      const product = this.productCommonObj.productList.find(
        (product) => product.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return product.text_bn
      } else {
        return product.text_en
      }
    },
    unitNameById (id) {
      const unit = this.productCommonObj.productUnitList.find(
        (unit) => unit.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return unit.text_bn
      } else {
        return unit.text_en
      }
    },
    getSalesCenterName (id) {
      const salesCenter = this.salesCenterList.find(
        (salescenter) => salescenter.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return salesCenter.text_bn
      } else {
        return salesCenter.text_en
      }
    }
  }
}
</script>
